import React, { Component } from 'react'
import PropTypes from 'prop-types'
import storeData from 'sb-store-data'
import { connect } from 'redaction'
import { constants, links, compose } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modal/ConfirmModal/ConfirmModal'

import messages from './messages'


class NeedChangeFrequencyModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    plan: PropTypes.object,
    isPaused: PropTypes.bool,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    data: PropTypes.shape({
      isMoveAction: PropTypes.bool,
      onCancel: PropTypes.func,
    }),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedChangeFrequency,
    title: messages.title,
    plan: {},
  }

  handleClickChangeFrequency = () => {
    const { plan: { name: planName, nextShippingDate, shippingPeriod }, isPaused, data: { isMoveAction } } = this.props

    this.close()
    actions.models.ui.showRequestLoader()
    actions.models.subscription.changePlan(planName, 'lep add to queue popup')
      .finally(() => {
        actions.models.ui.hideRequestLoader()
      })
      .then(() => {
        actions.models.modals.open(constants.modals.FrequencyChangeSuccess, { nextShippingDate, shippingPeriod })
        if (!isMoveAction) {
          actions.models.queue.resolveAllPostponedLimitedItems()
        }
      }, ({ statusCode }) => {
        if (statusCode !== '409' || !isPaused) {
          return actions.models.modals.open(constants.modals.SomethingWentWrong)
        }
        if (!isMoveAction) {
          actions.models.queue.removeAllPostponedLimitedItems()
        }

        // TODO seems it's unreachable
        // it's impossible to change plan with 'paused' subscription
        // checked by sonatskiy & eastashevich
        actions.models.payment.setUnpause(true)
        actions.models.router.push(links.cardUpdate)
      })
  }

  onCancel = () => {
    const { data: { onCancel, isMoveAction } } = this.props

    if (!isMoveAction) {
      actions.models.queue.resolveAllPostponedLimitedItems({ force: true })
    }

    if (typeof onCancel === 'function') {
      onCancel()
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.confirmButton}
        cancelTitle={messages.cancelButton}
        onConfirm={this.handleClickChangeFrequency}
        onCancel={this.close}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}


export default compose(
  storeData({
    plan: () => actions.models.subscription.fetchFrequencies()
      .then((result) => Object.values(result)
        .find(({ shippingPeriod }) => shippingPeriod === 1)),
  }),
  connect({
    isPaused: 'models.subscription.isPaused',
  }),
)(NeedChangeFrequencyModal)
